export default [
    {
        path: '/',
        redirect: '/dashboard',
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('./pages/Dashboard/Dashboard.vue'),
    },
    {
        path: '/resources',
        name: 'resources',
        component: () => import('./pages/Resources/Resources.vue'),
    },
    {
        path: '/referrals',
        name: 'referrals',
        component: () => import('./pages/Referrals/Referrals.vue'),
    },
    {
        path: '/referral/:id',
        name: 'referral-detail',
        component: () => import('./pages/Referrals/ReferralDetail.vue')
    },
    {
        path: '/leads',
        name: 'leads',
        component: () => import('./pages/Leads/Leads.vue'),
    },
    {
        path: '/payouts',
        name: 'payouts',
        component: () => import('./pages/Payouts/Payouts.vue'),
    },
    {
        path: '/reports',
        name: 'reports',
        component: () => import('./pages/Reports/Reports.vue'),
    },
    {
        path: '/messages',
        name: 'messages',
        component: () => import('./pages/Messages/Messages.vue'),
    },
    {
        path: '/affiliate-profile',
        name: 'affiliate-profile',
        component: () => import('./pages/Profile/Profile.vue'),
    },
    {
        path: '/accounts',
        name: 'accounts',
        component: () => import('./pages/Accounts/Accounts.vue'),
        meta: { restrictSubAccount: true },
    },
    {
        path: "/approval",
        name: "approval",
        component: () => import('./pages/Approval/Approval.vue'),
    },
    {
        path: "/complete_invitation/:key",
        name: "complete-invitation",
        component: () => import('./pages/Invites/CompleteInvitation.vue'),
    }

]
